import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { ScheduleInstanceTable } from "../ScheduleInstanceTable/ScheduleInstanceTable.logic";
import { IRootState } from "../../../../reducer/CombineReducer";
import { SaveSchedule } from "../SaveSchedule/SaveSchedule.logic";
import { SchedulingPopup } from "../SchedulingPopup/SchedulingPopup.logic";
import { ScheduleRemove } from "../ScheduleRemove/ScheduleRemove.logic";
import ScheduleLandingPage from "../SchedulingEntries/ScheduleLandingPage";
import { Button } from "../../../Common/UI/Index";
import { SchedulingModes } from "./redux/Types";
import ChevronLeft from "~icons/ic/outline-chevron-left";
import "./Style.scss";

interface ICreateScheduleViewProps {
  onClick: () => void;
  onSave: () => void;
  onEditClick: () => void;
}

// Responsible for rendering create schedule form
export const CreateScheduleView: React.FC<ICreateScheduleViewProps> = (props: ICreateScheduleViewProps) => {
  const { onClick, onSave } = props;
  const scheduling = useSelector((state: IRootState) => state.scheduling);
  const { isShowSchedulePopup } = scheduling;
  const isViewMode = scheduling.mode === SchedulingModes.VIEW;
  const isCreateMode = scheduling.mode === SchedulingModes.CREATE;
  const { t: translate } = useTranslation();
  const className = isCreateMode ? "ebt-new-schedule ebt-new-schedule__create" : "ebt-new-schedule";

  return (
    <div className={className}>
      <div className="ebt-new-schedule__header">
        <Button
          data-testid="ebt-new-schedule-go-back"
          title="back"
          borderless={true}
          onClick={onClick}
        >
          <ChevronLeft title="back" />
          {translate("Button.Back")}
        </Button>
        <div>
          <ScheduleRemove />
        </div>
      </div>
      <div className="ebt-new-schedule__content">
        <ScheduleLandingPage />
        <ScheduleInstanceTable />
        {
          isShowSchedulePopup &&
          <SchedulingPopup title={"Scheduling.Heading.EditRecurrence"} />
        }
      </div>
      {
        !isViewMode &&
        <SaveSchedule goBack={onClick} onSave={onSave} />
      }
    </div>
  );
};
